module.exports = __webpack_public_path__ + "assets/img/TLSC4-3.73c75b84.jpg";